import type { SVGProps } from 'react';
const SvgRequiredMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#fff"
      stroke="#234eee"
      d="M7.835 1.615a.18.18 0 0 1 .33 0l.982 2.235c.235.531.82.813 1.382.665l2.36-.624a.18.18 0 0 1 .206.257L11.96 6.31a1.18 1.18 0 0 0 .34 1.495l1.96 1.455a.18.18 0 0 1-.073.321l-2.397.462a1.18 1.18 0 0 0-.956 1.2l.084 2.438a.18.18 0 0 1-.297.142l-1.855-1.586a1.18 1.18 0 0 0-1.534 0l-1.855 1.586a.18.18 0 0 1-.297-.142l.084-2.439a1.18 1.18 0 0 0-.956-1.199l-2.396-.462a.18.18 0 0 1-.074-.321L3.7 7.805c.465-.347.61-.981.34-1.495L2.905 4.148a.18.18 0 0 1 .206-.257l2.36.624a1.18 1.18 0 0 0 1.382-.665z"
    />
  </svg>
);
export default SvgRequiredMark;
